/**
 * ClimateReportBlock
 * @module components/ClimateReportBlock
 */

import { ClimateReportBlockModel } from 'types/block-types';

import clsx from 'clsx';
import RichText from 'components/ui/RichText';
import Button from 'components/ui/Button';
import { t } from 'common/helpers';
import { useState } from 'react';
import ClimateReportBlockModal from './ClimateReportBlockModal';
import { ButtonColorTypes } from 'types';

const ClimateReportBlock = ({
	heading,
	text,
	image,
	button,
	climateReportApiUrl,
}: ClimateReportBlockModel) => {
	const [exportClimateModalOpen, setExportClimateModalOpen] = useState<boolean>(
		false
	);
	return (
		<>
			<section className="flex gap-4 justify-between items-center mx-auto max-w-site  py-6 flex-col md:flex-row">
				<div className="w-full md:w-1/2 rounded-card">
					{image && image.src && (
						<picture className={'rounded-card'}>
							{image.webpSizes && image.webpSizes.length > 0 && (
								<source
									type="image/webp"
									srcSet={`${image.webpSizes[0]} 800w ${
										image.webpSizes[1] ? `, ${image.webpSizes[1]} 400w` : ''
									}`}
									sizes="(min-width:768px) 60vw, (max-width:767px) 70vw, 800px"
								></source>
							)}
							<img
								src={image.src}
								srcSet={
									image.sizes && image.sizes?.length > 0
										? `${image.sizes[0]} 800w ${
												image.sizes[1] ? ` , ${image.sizes[1]} 400w` : ''
										  }`
										: undefined
								}
								sizes={
									image.sizes && image.sizes?.length > 0
										? '(min-width: 768px) 70vw, (max-width: 767px) 30vw, 800px'
										: undefined
								}
								alt={image.alt || ''}
								loading="lazy"
								className="object-center image-objectfit rounded-card"
							/>
						</picture>
					)}
				</div>
				<div className="w-full md:w-1/2 bg-white px-6 py-4 rounded-card">
					{heading && <h2 className="text-h2 text-blue pb-4">{heading}</h2>}
					{text && (
						<RichText
							className={clsx('text-p font-light mb-6  text-black')}
							text={text}
						/>
					)}
					{button && (
						<Button
							type="button"
							buttonColor={(button.color as ButtonColorTypes) || 'blue'}
							className="flex items-center justify-center"
							onClick={() => {
								setExportClimateModalOpen(true);
							}}
						>
							{button?.text}
						</Button>
					)}
				</div>
			</section>
			{exportClimateModalOpen && (
				<ClimateReportBlockModal
					onToggle={() => setExportClimateModalOpen(false)}
					climateReportApiUrl={climateReportApiUrl}
				/>
			)}
		</>
	);
};

export default ClimateReportBlock;
